/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MenuNodeType,
    MenuNodeTypeFromJSON,
    MenuNodeTypeFromJSONTyped,
    MenuNodeTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MenuNode
 */
export interface MenuNode {
    /**
     * 
     * @type {string}
     * @memberof MenuNode
     */
    id: string;
    /**
     * 
     * @type {MenuNodeType}
     * @memberof MenuNode
     */
    nodeType: MenuNodeType;
    /**
     * 
     * @type {string}
     * @memberof MenuNode
     */
    displayText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MenuNode
     */
    retailerId?: string | null;
    /**
     * Defines if a product is permanently mounted so that you can only
     * add one to the summary, and no other items from the same group can
     * be selected at the same time.
     * @type {boolean}
     * @memberof MenuNode
     */
    isPermanent: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuNode
     */
    group?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MenuNode
     */
    preferredSeries?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MenuNode
     */
    preferredFrames?: Array<number> | null;
    /**
     * 
     * @type {Array<MenuNode>}
     * @memberof MenuNode
     */
    children?: Array<MenuNode> | null;
}

export function MenuNodeFromJSON(json: any): MenuNode {
    return MenuNodeFromJSONTyped(json, false);
}

export function MenuNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'nodeType': MenuNodeTypeFromJSON(json['nodeType']),
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'retailerId': !exists(json, 'retailerId') ? undefined : json['retailerId'],
        'isPermanent': json['isPermanent'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'preferredSeries': !exists(json, 'preferredSeries') ? undefined : json['preferredSeries'],
        'preferredFrames': !exists(json, 'preferredFrames') ? undefined : json['preferredFrames'],
        'children': !exists(json, 'children') ? undefined : (json['children'] === null ? null : (json['children'] as Array<any>).map(MenuNodeFromJSON)),
    };
}

export function MenuNodeToJSON(value?: MenuNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'nodeType': MenuNodeTypeToJSON(value.nodeType),
        'displayText': value.displayText,
        'retailerId': value.retailerId,
        'isPermanent': value.isPermanent,
        'group': value.group,
        'preferredSeries': value.preferredSeries,
        'preferredFrames': value.preferredFrames,
        'children': value.children === undefined ? undefined : (value.children === null ? null : (value.children as Array<any>).map(MenuNodeToJSON)),
    };
}


